import React from 'react';
import { Theme, Box, makeStyles, useTheme } from '@material-ui/core';
import AvatarImage from './AvatarImage';
import { BasicProfileData } from '../types/types';
import { StyledText } from './StyledText';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'leading',
    width: 'auto'
  },
  textContainer: {
    marginLeft: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}));

interface BasicProfileProps {
  profile: BasicProfileData
}

const BasicProfileHolder: React.FC<BasicProfileProps> = ({
  profile
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { name, company, profileImgUrl } = profile;
  const profileImageProvider = {
    editable: false,
    imgUrl: profileImgUrl
  };

  return (
    <Box className={styles.root}>
      <AvatarImage profileImageProvider={profileImageProvider} size={40} />
      <Box className={styles.textContainer}>
        <StyledText variant='subtitle3'>{name}</StyledText>
        <StyledText variant='subtitle1'>{company}</StyledText>
      </Box>
    </Box>
  );
};

export default BasicProfileHolder;
